<template>

  <div class="v">
    
    <Select v-if="select" @back="onBackHome" @next="onCreate" />

    <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
      >
      
      <Create v-if="create" @next="onSign" @back="onBackSelect" :selectId="selectId" />

      <Sign v-if="sign" @next="onResult" :selectId="selectId" :resultImg="resultImg" />

      <Result v-if="result" 
        @share="onShare"
        @back="onBackHome" 
        :resultImg="resultImg"
        :textArray="textArray"
        :nameImg="nameImg"
        :bgColor="bgColor"
       />

      <Lottery v-if="lottery" @prev="onBackResult" @back="onBackHome" />

    </transition>

  </div>

</template>

<script>
import { setStore } from "@/util/store";
import Select from "@/components/Select";
import Create from "@/components/Create";
import Sign from "@/components/Sign";
import Result from "@/components/Result";
import Lottery from "@/components/Lottery";

export default {
  data() {
    return {
      selectId: 1,
      resultImg: '',
      nameImg: '',
      bgColor: require("@/images/create/bg/1.png"),

      select:  true,
      create:  false,
      sign:    false,
      result:  false,
      lottery: false,

      textArray: {},
      role: [
        '的火箭',
        '的太阳',
        '的跳跳糖',
        '的香蕉',
        '的蒙娜丽莎',
        '的蘑菇伞',
        '的香菜面包'
      ],
      character: ['达芬奇','梵高','莫奈','哥伦布','图灵','牛顿','奥斯卡','卓别林','拿破仑','爱迪生','特斯拉','毕加索','肖邦','爱因斯坦','莫扎特','苏格拉底'],
      words: ['活跃','灵巧','机敏','独创','浪漫','热情','幽默','冒险','叛逆','自由','调皮','细致','乐观','聪慧','机智','天真','忧郁','果断','幻想','克制','冲动','新奇','固执'],
      texts: [
        '要穿破天际',
        '想和云朵牵手',
        '立志捣蛋到太空',
        '不屑拿全勤奖',
        '永远在发怒',
        '不舍得开空调',
        '习惯冷暴力',
        '奇特怪味',
        '被妈妈藏起来的',
        '企图征服世界的',
        '香菜面包',
        '在危险边缘试探',
        '夺得果运会平衡木冠军',
        '不是很想上网课',
        '只会大喊大叫',
        '故意打翻颜料盘',
        '不穿鞋还要跳',
        '出自7岁孩子手下',
        '说是能替换真品',
        '做报复性熬夜选手',
        '自带危险毒素',
        '会摇摇晃晃',
        '想亲吻雨滴',
        '努力拼凑可爱'
      ],
      ending: [
        "不是故意惹你生气的\n把你气的鼓鼓的，你就能飞出地球了",
        '我想把太阳关起来\n这样月亮就不用通宵上班了',
        '想变成一颗跳跳糖\n刺激一下无聊的生活',
        '喜欢走边边的人\n正在维持地球的平衡',
        '把蒙娜丽莎偷走\n送给正在哭泣的朋友',
        '在下水道种蘑菇\n下雨天就不会淋湿了',
        '也想要不听话一次\n妈妈，我真的不要吃香菜！'
      ]
    };
  },
  components: {
    Select,
    Create,
    Sign,
    Result,
    Lottery,
  },
  mounted() {
  },
  methods: {
    onBackHome() {
      this.$emit("back");
    },
    onBackSelect() {
      this.onHide();
      this.select = true;
    },
    onBackResult() {
      this.onHide();
      this.result = true;
    },
    onShare() {
      this.onHide();
      this.lottery = true;
    },
    onHide() {
      this.select  = false;
      this.create  = false;
      this.sign    = false;
      this.result  = false;
      this.lottery = false;
    },
    onSelect() {
      this.onHide();
      this.select = true;
    },
    onCreate(id) {
      console.log(id)
      this.selectId = id;
      this.onHide();
      this.create = true;
    },
    onSign(data) {
      console.log(data)
      this.resultImg = data.resultImg;
      this.bgColor   = data.bgColor;
      this.onHide();
      this.sign = true;
    },
    onResult(img) {
      console.log(img)
      this.nameImg = img;

      // 主角，根据selectId匹配
      var role = this.role[this.selectId-1];

      // 你的创作气质同XXX较为贴近
      // 分析出你的不太乖因子由15% XX＋8% XX构成
      // 名人，随机取1
      var n = Math.floor(Math.random() * this.character.length + 1)-1;
      var character = this.character[n];
      this.textArray.p1 = '你的创作气质同'+character+'较为贴近';
      
      // 词库，随机取2
      var word = this.getRandomArrayElements(this.words, 2);
      var num1 = Math.round(Math.random()*50)+1;
      var num2 = Math.round(Math.random()*50)+1;
      this.textArray.p2 = '分析出你的不太乖因子由'+num1+'%'+word[0]+'＋'+num2+'%'+word[1]+'构成';

      // 形容词，随机取3
      var text = this.getRandomArrayElements(this.texts, 3);
      this.textArray.p3 = text[0]+text[1]+text[2]+role;
      // this.textArray.p3 = '夺得果运会平衡木冠军做报复性熬夜选手企图征服世界的的蒙娜丽莎';

      // 结尾词，根据selectId匹配
      this.textArray.p4 = this.ending[this.selectId-1];
      // this.textArray.p4 = '不是故意惹你生气的<br/>把你气的鼓鼓的，你就能飞出地球了',
      this.textArray.p5 = this.textArray.p4.replace(/\n/g,"<br>");

      // 缓存
      setStore({name: 'textArray', content: this.textArray});
      console.log(this.textArray);

      this.onHide();

      this.result = true;
    },
    onLottery() {
      this.onHide();
      this.lottery = true;
    },
    getRandomArrayElements(arr, count) {
      var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {
          index = Math.floor((i + 1) * Math.random());
          temp = shuffled[index];
          shuffled[index] = shuffled[i];
          shuffled[i] = temp;
      }
      return shuffled.slice(min);
    }
  },
};
</script>

<style scoped lang="less">
</style>
